import axios from 'axios';
import { API_BASE_URL } from '@/modules/shared/constants';
import type { RolesWithStaffResponse, AssignRoleParams, RevokeRoleParams, SetDefaultAssigneeParams } from '../types';

// Role Management API endpoints
const endpoints = {
  rolesWithStaff: `${API_BASE_URL}/crm/roles-with-staff`,
  assignRole: `${API_BASE_URL}/crm/assign-role`,
  revokeRole: `${API_BASE_URL}/crm/revoke-role`,
  setDefaultAssignee: `${API_BASE_URL}/crm/set-default-assignee`,
  searchUser: `${API_BASE_URL}/crm/search-user`,
};

/**
 * Fetch all roles with their assigned staff
 * @returns Promise with roles and staff data
 */
export const getRolesWithStaff = async (): Promise<RolesWithStaffResponse> => {
  const response = await axios.get(endpoints.rolesWithStaff);
  return response.data;
};

/**
 * Search users for role assignment
 * @param search Search query string
 * @returns Promise with array of matching users
 */
export const searchUsers = async (search: string) => {
  const response = await axios.get(endpoints.searchUser, {
    params: { search },
  });
  return response.data;
};

/**
 * Assign a role to a user
 * @param params User ID and role to assign
 * @returns Promise with assignment result
 */
export const assignRole = async (params: AssignRoleParams) => {
  const response = await axios.post(endpoints.assignRole, params);
  return response.data;
};

/**
 * Revoke a role from a user
 * @param params User ID and role to revoke
 * @returns Promise with revocation result
 */
export const revokeRole = async (params: RevokeRoleParams) => {
  const response = await axios.post(endpoints.revokeRole, params);
  return response.data;
};

/**
 * Set a user as the default assignee for a role
 * @param params User ID and role
 * @returns Promise with result
 */
export const setDefaultAssignee = async (params: SetDefaultAssigneeParams) => {
  const response = await axios.post(endpoints.setDefaultAssignee, params);
  return response.data;
};
